import { render, staticRenderFns } from "./DashboardVendasAntiga.vue?vue&type=template&id=1e28b4e6&scoped=true"
import script from "./DashboardVendasAntiga.vue?vue&type=script&lang=js"
export * from "./DashboardVendasAntiga.vue?vue&type=script&lang=js"
import style0 from "./DashboardVendasAntiga.vue?vue&type=style&index=0&id=1e28b4e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e28b4e6",
  null
  
)

export default component.exports